import * as React from 'react';
import classnames from 'classnames';
import { useProductDetailSlots } from '../../slots/context.js';
import { ProductDetailUspItem } from './components/ProductDetailUspItem/ProductDetailUspItem.js';

const ProductDetailUsps = ({ items , layout ='list' , className  })=>{
    const { Slots  } = useProductDetailSlots();
    if ((!items || !items.length) && !Slots.BeforeUsps) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(className, 'product-detail-usps', `product-detail-usps--layout-${layout}`, {
            [`product-detail-usps--columns-3`]: layout === 'grid'
        }),
        "data-t": "product-detail-usps"
    }, Slots.BeforeUsps && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-usps__before"
    }, /*#__PURE__*/ React.createElement(Slots.BeforeUsps, null)), items && items.map((usp)=>/*#__PURE__*/ React.createElement(ProductDetailUspItem, {
            item: usp,
            key: usp.text
        })
    ));
};

export { ProductDetailUsps };
//# sourceMappingURL=ProductDetailUsps.js.map
